import React, {useEffect, useState} from 'react'

export interface InputColourPickerProps {
  id?: string
  name?: string
  label?: string
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  error?: any
  isRequired?: boolean
  disabled?: boolean
  className?: string
  inputClass?: string
  labelClass?: string
  register?: any // react-hook-form register
  isHexOnly?: boolean
}

const InputColourPicker: React.FC<InputColourPickerProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  error,
  isRequired = false,
  disabled = false,
  className = '',
  inputClass = '',
  labelClass = '',
  register,
  isHexOnly = false,
  ...rest
}) => {
  const [colorValue, setColorValue] = useState(value || '#000000')

  // Handle form registration
  const {onChange: registerOnChange, ref, ...registerRest} = register || {}

  // Update local state when form value changes
  useEffect(() => {
    if (value) {
      setColorValue(value)
    }
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setColorValue(newValue)

    // Create a custom event with the hex value
    const customEvent = {
      ...e,
      target: {
        ...e.target,
        value: isHexOnly ? newValue.toUpperCase() : newValue,
        name: name || id,
      },
    }

    // Call both form's onChange and component's onChange
    if (registerOnChange) registerOnChange(customEvent)
    if (onChange) onChange(customEvent as any)
  }

  return (
    <div className={className}>
      {label && (
        <label className={`form-label ${labelClass} ${isRequired ? 'required' : ''}`}>
          {label}
        </label>
      )}
      <div className='d-flex align-items-center gap-3'>
        <input
          id={id}
          type='color'
          name={name}
          ref={ref}
          value={colorValue}
          onChange={handleChange}
          className={`form-control form-control-color h-30px w-30px  ${inputClass} ${
            error ? 'is-invalid' : ''
          }`}
          disabled={disabled}
          style={{width: 40, height: 40, padding: 0, border: 'none', background: 'none'}}
          {...registerRest}
          {...rest}
        />
        <span className='fw-bold'>{isHexOnly ? colorValue.toUpperCase() : colorValue}</span>
      </div>
      {error && error.message && <div className='invalid-feedback'>{error.message}</div>}
    </div>
  )
}

export default InputColourPicker
